import { createStyles, makeStyles } from "@material-ui/core/styles";
import { TextBlock } from "neon-design-system";
import React from "react";

const useStyles = makeStyles((theme) =>
  createStyles({
    root: {
      flex: 1,
      display: "flex",
      flexDirection: "column",
      gap: 18,
      alignItems: "stretch",
      justifyContent: "center",
      minHeight: "fit-content",
      paddingInline: theme.spacing(4),
      paddingTop: theme.spacing(4),
      paddingBottom: theme.spacing(8),
    },
    title: {
      maxWidth: 500,
      fontSize: 32,
      lineHeight: "1.2em",
    },
    subtitle: {
      maxWidth: 500,
      fontSize: 24,
      lineHeight: "1.2em",
    },
  })
);

export const NotFound = ({ fullHeight }: { fullHeight?: boolean }) => {
  const classes = useStyles();
  return (
    <div
      className={classes.root}
      style={fullHeight ? { height: "100dvh" } : {}}
    >
      <TextBlock styleName="largeBody1" className={classes.title}>
        Page not found
      </TextBlock>

      <TextBlock styleName="largeBody2" className={classes.subtitle}>
        The page you're looking for doesn't exist or has been moved.
      </TextBlock>
    </div>
  );
};
